export default "__VITE_ASSET__V_vicAZI__"